import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsOfficesGroupDrawer, isOpenUserSettingsOfficesGroupDrawer, userSettingsOfficesGroupFormData } from "../../@signals"
import UserSettingOfficesGroupDrawerName from "./Name"
import UserSettingOfficesGroupDrawerOffices from "./Offices"
import UserSettingOfficesGroupDrawerSubmit from "./Submit"


export default function UserSettingOfficesGroupDrawer() {
	const onClose = () => userSettingsOfficesGroupFormData.value = { }

	return <AppFormDrawer
		icon="city"
		title={isEditUserSettingsOfficesGroupDrawer.value ? 'Edit office group' : 'New office group'}
		subtitle="A name and the offices it groups"
		isOpen={isOpenUserSettingsOfficesGroupDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingOfficesGroupDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="city" title="Office group">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingOfficesGroupDrawerName/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingOfficesGroupDrawerOffices/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
